import { render, staticRenderFns } from "./investor-research.vue?vue&type=template&id=0a862141"
import script from "./investor-research.vue?vue&type=script&lang=js"
export * from "./investor-research.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports